import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Play } from "lucide-react";

const RACE_KEY = "supera_race_active";

const readRace = () => {
  try {
    const raw = localStorage.getItem(RACE_KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d || !d.mes) return null;
    return d;
  } catch {
    return null;
  }
};

export default function RaceResumeBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const [race, setRace] = useState(null);

  useEffect(() => {
    const check = () => setRace(readRace());
    check();
    const id = setInterval(check, 1500);
    window.addEventListener("supera-race-update", check);
    window.addEventListener("storage", check);
    return () => {
      clearInterval(id);
      window.removeEventListener("supera-race-update", check);
      window.removeEventListener("storage", check);
    };
  }, []);

  useEffect(() => {
    setRace(readRace());
  }, [location.pathname]);

  // No mostrar en la propia página de la carrera (ahí se maneja en la vista).
  if (!race || location.pathname === "/carrera") return null;

  const km = ((race.dist || 0) / 1000).toFixed(2);
  const running = !!(race.running && race.segStart);

  return (
    <button
      data-testid="race-resume-banner"
      onClick={() => navigate("/carrera")}
      className="fixed left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-full bg-[#0A1C30] text-white pl-4 pr-2 py-2 shadow-2xl ring-1 ring-white/10 active:scale-95 transition-transform"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 1rem)" }}
    >
      <span className="relative flex h-2.5 w-2.5">
        {running && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#E9A400] opacity-75" />}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${running ? "bg-[#E9A400]" : "bg-white/50"}`} />
      </span>
      <span className="text-left leading-tight">
        <span className="block text-[11px] font-bold text-[#E9A400]">{running ? "Carrera en curso" : "Carrera en pausa"}</span>
        <span className="block text-xs font-semibold text-white/80">{km} km · Toca para reanudar</span>
      </span>
      <span className="ml-1 grid place-items-center w-9 h-9 rounded-full bg-[#E9A400] text-[#0A1C30]">
        <Play className="w-4 h-4" />
      </span>
    </button>
  );
}
